/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} editPostImageStartUploadingParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - image type - cover, avatar, post editor
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit post -> Image start uploading. Evid: 551.
 * Event description: event triggered when a user start to upload Image (comes together with Image finish uploading for success rate).

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: image type - cover, avatar, post editor
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editPostImageStartUploadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editPostImageStartUploading = function (params) {
    return { evid: 551, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} forumPostsSortParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - app site id
* @property {GUID} instance_id - null
* @property {string} member_id - memeber id
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {string} sort_by - newest, oldest, number of comments, number of views or number of likes
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - null
**/
/**
 * Name: Forum posts - sort. Evid: 563.
 * Event description: Event triggered when sorting posts.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: memeber id
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * sort_by - Type: string. Desc: newest, oldest, number of comments, number of views or number of likes
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid.
 * @param {forumPostsSortParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forumPostsSort = function (params) {
    return { evid: 563, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonRemoveModeratorPopupConfirmationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> remove moderator popup confirmation click. Evid: 580.
 * Event description: Event triggered when clicking confirm in the popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonRemoveModeratorPopupConfirmationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonRemoveModeratorPopupConfirmationClick = function (params) {
    return { evid: 580, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} profilePageEditProfileClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: profile page -> edit profile click. Evid: 538.
 * Event description: Event triggered when clicking on edit profile button.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {profilePageEditProfileClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var profilePageEditProfileClick = function (params) {
    return { evid: 538, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickSeeAllResultsInSearchFieldParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - search_results, post_page, post_edit_page, feed_page, categories_page, create_post, categories_tab, all_posts_tab, my_posts_tab
* @property {GUID} post_stable_id - null
* @property {string} search_term - search term written in search box before click on "See All Results"/Enter
* @property {string} search_trigger - see_all_results, enter
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: click "See All Results" in search field. Evid: 114.
 * Event description: Event triggered when UoU/User clicks "See All Results"/or enter in search field.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: search_results, post_page, post_edit_page, feed_page, categories_page, create_post, categories_tab, all_posts_tab, my_posts_tab
 *
 * post_stable_id - Type: guid.
 *
 * search_term - Type: string. Desc: search term written in search box before click on "See All Results"/Enter
 *
 * search_trigger - Type: string. Desc: see_all_results, enter
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {clickSeeAllResultsInSearchFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickSeeAllResultsInSearchField = function (params) {
    return { evid: 114, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postIsReportedWixAppParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} msid - msid
* @property {GUID} biToken - null
* @property {GUID} owner_id - post owner id
* @property {GUID} post_id - reported post id
* @property {GUID} post_stable_id - null
* @property {string} type - 'spam'/'violence'/'harassment'/'nudity or sexual activity'/'other'
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - null
**/
/**
 * Name: Post is reported - Wix App. Evid: 570.
 * Event description: Event triggered when the post is reported in Wix App.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * biToken - Type: guid.
 *
 * owner_id - Type: guid. Desc: post owner id
 *
 * post_id - Type: guid. Desc: reported post id
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: 'spam'/'violence'/'harassment'/'nudity or sexual activity'/'other'
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid.
 * @param {postIsReportedWixAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postIsReportedWixApp = function (params) {
    return { evid: 570, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} whoLikedPostClickParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - post_page
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} reaction_type - "likes" or "reactions"
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: who liked post click. Evid: 596.
 * Event description: Event triggered when a user click to view who liked a post on the web.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: post_page
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * reaction_type - Type: string. Desc: "likes" or "reactions"
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {whoLikedPostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var whoLikedPostClick = function (params) {
    return { evid: 596, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postDeletedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} category_posts_format - discussion / question / all
* @property {GUID} instance_id - instance_id
* @property {boolean} is_admin - 0 - not the admin / 1 - the admin
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - msid
* @property {string} origin - live / business_manager / member_posts_page /  member_comments_page
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: post deleted. Evid: 555.
 * Event description: Event triggered after post is deleted.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * category_posts_format - Type: string. Desc: discussion / question / all
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * is_admin - Type: bool. Desc: 0 - not the admin / 1 - the admin
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: live / business_manager / member_posts_page /  member_comments_page
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {postDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postDeleted = function (params) {
    return { evid: 555, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonSharePopupCancelClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - feed_page, post_page, search_results, user_profile
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> share popup cancel click. Evid: 531.
 * Event description: Event triggered when clicking x on the share popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonSharePopupCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonSharePopupCancelClick = function (params) {
    return { evid: 531, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postPublishedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} approved_by - approver_id (NULL if post was published without approval)
* @property {string} approver_role - role of approver (NULL if post was published without approval)
* @property {string} captcha_used - 1 - if post was created after solving captcha; 0 - post created without captcha
* @property {boolean} category_changed - 0 - didnt change category / 1 - did change category
* @property {string} category_id - category id
* @property {string} cta_origin - main_page; category
* @property {number} file_count - Number of files attached to a post
* @property {string} guidelines_type - forum, category, NULL
* @property {boolean} has_emoji - 0 - no emoji / 1 - with emoji
* @property {boolean} has_gallery - 0 - no gallery, 1 - with gallery
* @property {boolean} has_gif - 0 - no gif / 1 - has gif
* @property {boolean} has_hashtag - 0 - no hashtag / 1 - has hashtag
* @property {boolean} has_image - 0 - no image / 1 - with image
* @property {boolean} has_mention - 0 - no mention / 1 - with mention
* @property {boolean} has_poll - 0 - no poll / 1 - with poll
* @property {boolean} has_quote - 0 - no quote / 1 - with quote
* @property {boolean} has_video - 0 - no video/ 1 - with video
* @property {number} hashtag_count - the number of hashtags in post
* @property {number} image_count - the number of images in the post
* @property {number} image_in_gallery_count - the number of images in gallery
* @property {string} initiated_by - comment_bar, NULL
* @property {GUID} instance_id - null
* @property {boolean} is_admin - 0 - not the admin / 1 - the admin
* @property {boolean} is_custom_video - 0 - no custom video / 1 - has video uploaded through video upload
* @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
* @property {string} media_source - "file"(when uploading file in web) / "gallery"(when uploading file from oneApp ) / "camera" (for oneApp)  / "link" (adding video using link in Web)
* @property {string} member_id - the member_id after login to Wix forum
* @property {number} mention_count - the number of mentions in post
* @property {GUID} biToken - msid
* @property {string} origin - WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post,  / business_manager
* @property {string} parent_post_id - parent post/question guid for comment, reply. Null if initial post.
* @property {string} post_id - post/comment/reply guid
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment,  reply, general
* @property {GUID} visitor_id - null
* @property {boolean} was_category_selected - 0 - category was not selected / 1 - category was selected
**/
/**
 * Name: post published. Evid: 523.
 * Event description: Event triggered after post is published.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * approved_by - Type: guid. Desc: approver_id (NULL if post was published without approval)
 *
 * approver_role - Type: string. Desc: role of approver (NULL if post was published without approval)
 *
 * captcha_used - Type: string. Desc: 1 - if post was created after solving captcha; 0 - post created without captcha
 *
 * category_changed - Type: bool. Desc: 0 - didnt change category / 1 - did change category
 *
 * category_id - Type: string. Desc: category id
 *
 * cta_origin - Type: string. Desc: main_page; category
 *
 * file_count - Type: numeric. Desc: Number of files attached to a post
 *
 * guidelines_type - Type: string. Desc: forum, category, NULL
 *
 * has_emoji - Type: bool. Desc: 0 - no emoji / 1 - with emoji
 *
 * has_gallery - Type: bool. Desc: 0 - no gallery, 1 - with gallery
 *
 * has_gif - Type: bool. Desc: 0 - no gif / 1 - has gif
 *
 * has_hashtag - Type: bool. Desc: 0 - no hashtag / 1 - has hashtag
 *
 * has_image - Type: bool. Desc: 0 - no image / 1 - with image
 *
 * has_mention - Type: bool. Desc: 0 - no mention / 1 - with mention
 *
 * has_poll - Type: bool. Desc: 0 - no poll / 1 - with poll
 *
 * has_quote - Type: bool. Desc: 0 - no quote / 1 - with quote
 *
 * has_video - Type: bool. Desc: 0 - no video/ 1 - with video
 *
 * hashtag_count - Type: numeric. Desc: the number of hashtags in post
 *
 * image_count - Type: numeric. Desc: the number of images in the post
 *
 * image_in_gallery_count - Type: numeric. Desc: the number of images in gallery
 *
 * initiated_by - Type: string. Desc: comment_bar, NULL
 *
 * instance_id - Type: guid.
 *
 * is_admin - Type: bool. Desc: 0 - not the admin / 1 - the admin
 *
 * is_custom_video - Type: bool. Desc: 0 - no custom video / 1 - has video uploaded through video upload
 *
 * is_edited - Type: bool. Desc: 0 - new post / 1 - edit (to know if its posted for first time)
 *
 * media_source - Type: string. Desc: "file"(when uploading file in web) / "gallery"(when uploading file from oneApp ) / "camera" (for oneApp)  / "link" (adding video using link in Web)
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * mention_count - Type: numeric. Desc: the number of mentions in post
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post,  / business_manager
 *
 * parent_post_id - Type: string. Desc: parent post/question guid for comment, reply. Null if initial post.
 *
 * post_id - Type: string. Desc: post/comment/reply guid
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment,  reply, general
 *
 * visitor_id - Type: guid.
 *
 * was_category_selected - Type: bool. Desc: 0 - category was not selected / 1 - category was selected
 * @param {postPublishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postPublished = function (params) {
    return { evid: 523, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} profilePageProfilePageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - log_in_bar_widget, external_link (url, google), breadcrumbs, feed_page, search_results, post_page
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: profile page -> profile page opened. Evid: 537.
 * Event description: Event triggered when profile page opened.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: log_in_bar_widget, external_link (url, google), breadcrumbs, feed_page, search_results, post_page
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {profilePageProfilePageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var profilePageProfilePageOpened = function (params) {
    return { evid: 537, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editingPostWindowCancelPostClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} discard_type - X, cancel, outside_click
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: editing post window -> cancel post click (discard). Evid: 507.
 * Event description: event triggered when a user click on cancel in the post edit window. event is also relevant for new posts! not just edit.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * discard_type - Type: string. Desc: X, cancel, outside_click
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {editingPostWindowCancelPostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editingPostWindowCancelPostClick = function (params) {
    return { evid: 507, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} membersPageSearchResultsParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
* @property {GUID} post_stable_id - null
* @property {string} referral_info - direct
* @property {number} result_count_members - int
* @property {string} search_term - what the user typed
* @property {GUID} visitor_id - null
**/
/**
 * Name: members page -> search results. Evid: 559.
 * Event description: Event triggered when searching in the members page.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
 *
 * post_stable_id - Type: guid.
 *
 * referral_info - Type: string. Desc: direct
 *
 * result_count_members - Type: numeric. Desc: int
 *
 * search_term - Type: string. Desc: what the user typed
 *
 * visitor_id - Type: guid.
 * @param {membersPageSearchResultsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersPageSearchResults = function (params) {
    return { evid: 559, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} customErrorPageRenderedParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} application_type - web/oneapp
* @property {string} error_data - error data if possible
* @property {GUID} instance_id - instance id
* @property {string} member_id - member id
* @property {GUID} biToken - site guid
* @property {GUID} post_stable_id - null
* @property {string} site_member_id - the member_id after login to Wix forum
* @property {string} view_mode - ADI/Editor/Preview/Live
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Custom error page rendered. Evid: 591.
 * Event description: When we render a custom error page when an unhandled exception is thrown by a request.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * application_type - Type: string. Desc: web/oneapp
 *
 * error_data - Type: string. Desc: error data if possible
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string. Desc: member id
 *
 * biToken - Type: guid. Desc: site guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * view_mode - Type: string. Desc: ADI/Editor/Preview/Live
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {customErrorPageRenderedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customErrorPageRendered = function (params) {
    return { evid: 591, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} searchTabDropListShowedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - categories_tab/all_posts_tab/my_posts_tab
* @property {GUID} post_stable_id - null
* @property {string} search_term - search term
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Search tab drop list showed. Evid: 113.
 * Event description: Event triggered when UoU writes in search box and drop list appears.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: categories_tab/all_posts_tab/my_posts_tab
 *
 * post_stable_id - Type: guid.
 *
 * search_term - Type: string. Desc: search term
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {searchTabDropListShowedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchTabDropListShowed = function (params) {
    return { evid: 113, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} goToProfileClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - instance_id
* @property {boolean} is_my_profile - 1 - is own profile , 0 - not
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - msid
* @property {string} origin - feed_page, post_page, search_results
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: go to profile click. Evid: 513.
 * Event description: Event triggered when clicking on avatar.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * is_my_profile - Type: bool. Desc: 1 - is own profile , 0 - not
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: feed_page, post_page, search_results
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {goToProfileClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goToProfileClick = function (params) {
    return { evid: 513, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} forumImageExpandParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} post_id - post id
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post / comment / reply
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Forum - Image expand. Evid: 593.
 * Event description: When user clicks on image to expand it.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_id - Type: string. Desc: post id
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post / comment / reply
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {forumImageExpandParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forumImageExpand = function (params) {
    return { evid: 593, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editUserUsernameChangedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit user -> username changed. Evid: 542.
 * Event description: Event triggered after changing username.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editUserUsernameChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editUserUsernameChanged = function (params) {
    return { evid: 542, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonMoveCategoryPopupCancelClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> move category popup cancel click. Evid: 534.
 * Event description: Event triggered when clicking cancel on the move to popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonMoveCategoryPopupCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonMoveCategoryPopupCancelClick = function (params) {
    return { evid: 534, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} archiveEventNotInUse520Params
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results, null
* @property {GUID} original_instance_id - original_instance_id
* @property {GUID} post_stable_id - null
* @property {string} trigger - login_bar_widget, create_new_post, comment_login, follow_user, category_for_members_only
* @property {GUID} visitor_id - null
**/
/**
 * Name: archive event - not in use. Evid: 520.
 * Event description: archive event - not in use.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results, null
 *
 * original_instance_id - Type: guid. Desc: original_instance_id
 *
 * post_stable_id - Type: guid.
 *
 * trigger - Type: string. Desc: login_bar_widget, create_new_post, comment_login, follow_user, category_for_members_only
 *
 * visitor_id - Type: guid.
 * @param {archiveEventNotInUse520Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var archiveEventNotInUse520 = function (params) {
    return { evid: 520, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} membersPageMembersPageOpenedParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: members page -> members page opened. Evid: 558.
 * Event description: Event triggered when the members page opened.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {membersPageMembersPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersPageMembersPageOpened = function (params) {
    return { evid: 558, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} createPostIntentParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - Web: live / business_manager; WixApp: live / plus_button / business_manager /
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Create post intent. Evid: 79.
 * Event description: Event triggered when clicking on create new post button just before the choice of questions or discussions.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: Web: live / business_manager; WixApp: live / plus_button / business_manager /
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {createPostIntentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var createPostIntent = function (params) {
    return { evid: 79, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonReportPopupConfirmationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} report_reason - inappropirate_lang, offensive_media, spam
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> report popup confirmation click. Evid: 529.
 * Event description: Event triggered when clicking report on the report popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * report_reason - Type: string. Desc: inappropirate_lang, offensive_media, spam
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonReportPopupConfirmationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonReportPopupConfirmationClick = function (params) {
    return { evid: 529, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editUserCoverPhotoChangeClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit user -> cover photo change click. Evid: 557.
 * Event description: Event triggered after clicking on changing cover image. this is the 'try' event of 541.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editUserCoverPhotoChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editUserCoverPhotoChangeClick = function (params) {
    return { evid: 557, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} followPostClickWixAppParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} msid - msid
* @property {GUID} biToken - null
* @property {GUID} owner_id - post owner id
* @property {string} post_followed - the post_id that had been followed
* @property {GUID} post_stable_id - null
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - null
**/
/**
 * Name: Follow post click - Wix App. Evid: 569.
 * Event description: Event triggered when clicking on follow post button in Wix App.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * msid - Type: guid. Desc: msid
 *
 * biToken - Type: guid.
 *
 * owner_id - Type: guid. Desc: post owner id
 *
 * post_followed - Type: string. Desc: the post_id that had been followed
 *
 * post_stable_id - Type: guid.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid.
 * @param {followPostClickWixAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followPostClickWixApp = function (params) {
    return { evid: 569, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonReportPopupCancelClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> report popup cancel click. Evid: 533.
 * Event description: Event triggered when clicking cancel on the report popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonReportPopupCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonReportPopupCancelClick = function (params) {
    return { evid: 533, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postPageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {boolean} is_new - true - post is new / false - post is not new
* @property {boolean} is_read - true - post is already read / false - post was marked as unread
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - WEB: dashboard_activity_widget, feed_page, post_edit_page, categories_page, search_results, create_post, post_sidebar, post_list_item_recent_activity, business_manager, member_posts_page, member_comments_page, widget, search_dropdown
* @property {number} origin_page_nr - page from which post was opened (in feed_page and search_results)
* @property {string} post_id - post_id guid
* @property {string} post_slug - post_slug
* @property {GUID} post_stable_id - null
* @property {string} post_title - post_slug
* @property {string} posts_format - discussion / question / all
* @property {string} search_term - null if didnt come from search
* @property {GUID} site_member_id - site_member_id
* @property {number} total_pages - how many pages with comments (in case there are more 20 comments)
* @property {string} type - post_page, comment, recent_activity
* @property {GUID} visitor_id - null
**/
/**
 * Name: post page opened. Evid: 517.
 * Event description: Event triggered when post opened.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * is_new - Type: bool. Desc: true - post is new / false - post is not new
 *
 * is_read - Type: bool. Desc: true - post is already read / false - post was marked as unread
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: WEB: dashboard_activity_widget, feed_page, post_edit_page, categories_page, search_results, create_post, post_sidebar, post_list_item_recent_activity, business_manager, member_posts_page, member_comments_page, widget, search_dropdown
 *
 * origin_page_nr - Type: numeric. Desc: page from which post was opened (in feed_page and search_results)
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_slug - Type: string. Desc: post_slug
 *
 * post_stable_id - Type: guid.
 *
 * post_title - Type: string. Desc: post_slug
 *
 * posts_format - Type: string. Desc: discussion / question / all
 *
 * search_term - Type: string. Desc: null if didnt come from search
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * total_pages - Type: numeric. Desc: how many pages with comments (in case there are more 20 comments)
 *
 * type - Type: string. Desc: post_page, comment, recent_activity
 *
 * visitor_id - Type: guid.
 * @param {postPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postPageOpened = function (params) {
    return { evid: 517, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} membersPageSortParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - feed_page, user_profile
* @property {GUID} post_stable_id - null
* @property {string} sort_by - (role, num of posts, etc')
* @property {GUID} visitor_id - null
**/
/**
 * Name: members page -> sort. Evid: 560.
 * Event description: Event triggered when sorting posts.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, user_profile
 *
 * post_stable_id - Type: guid.
 *
 * sort_by - Type: string. Desc: (role, num of posts, etc')
 *
 * visitor_id - Type: guid.
 * @param {membersPageSortParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersPageSort = function (params) {
    return { evid: 560, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickOnShowHideGuidelinesParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category_id guid
* @property {boolean} flag - 1 - show guidelines. 0 - hide guidelines or 'X'
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - forum_guidelines; category_guidelines
* @property {GUID} visitor_id - null
**/
/**
 * Name: Click on Show / Hide guidelines. Evid: 90.
 * Event description: Event triggered when site member click 'Show guidelines' / 'Hide guidelines' / 'X'.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category_id guid
 *
 * flag - Type: bool. Desc: 1 - show guidelines. 0 - hide guidelines or 'X'
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: forum_guidelines; category_guidelines
 *
 * visitor_id - Type: guid.
 * @param {clickOnShowHideGuidelinesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnShowHideGuidelines = function (params) {
    return { evid: 90, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickToWriteCommentReplyParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - comment_bar, NULL
* @property {GUID} post_stable_id - null
* @property {string} type - comment, reply
* @property {GUID} uuid - user guid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: click to write comment/reply. Evid: 588.
 * Event description: Happens when a user/member/visitor clicks on "reply", "comment" or directly clicks on the "Write a comment" box.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: comment_bar, NULL
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: comment, reply
 *
 * uuid - Type: guid. Desc: user guid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {clickToWriteCommentReplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToWriteCommentReply = function (params) {
    return { evid: 588, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonActionClickParams
* @property {string} action - ( pin, edit, delete, lock, move_category, share, report, follow_post, block_user, settings, logout, top comment, mark_as_best, report_post, report_comment , move-post, mark_as_unread, mark_as_read, mark_all_as_read, publish_post)
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} application_type - OneApp / Web
* @property {string} category_posts_format - discussion / question / all
* @property {string} comment_id - Comment id
* @property {GUID} comment_owner_id - Comment owner guid
* @property {boolean} flag - 0 - unpin, unlock, unfollow / 1 - pin, lock, follow (for pin / lock / follow post - for other will be null)
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} name - action_click (added because dev sends it)
* @property {string} origin - feed_page, post_page, search_results, user_profile
* @property {string} parent_post_id - parent post id if action is performed on comment or reply. otherwise null
* @property {string} post_id - post_id guid (only from post / comment. if not from post send null)
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment (only from post / comment. if not from post send null)
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> action click. Evid: 526.
 * Event description: Event triggered when clicking on one of the actions.

 * action - Type: string. Desc: ( pin, edit, delete, lock, move_category, share, report, follow_post, block_user, settings, logout, top comment, mark_as_best, report_post, report_comment , move-post, mark_as_unread, mark_as_read, mark_all_as_read, publish_post)
 *
 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * application_type - Type: string. Desc: OneApp / Web
 *
 * category_posts_format - Type: string. Desc: discussion / question / all
 *
 * comment_id - Type: string. Desc: Comment id
 *
 * comment_owner_id - Type: guid. Desc: Comment owner guid
 *
 * flag - Type: bool. Desc: 0 - unpin, unlock, unfollow / 1 - pin, lock, follow (for pin / lock / follow post - for other will be null)
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * name - Type: string. Desc: action_click (added because dev sends it)
 *
 * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
 *
 * parent_post_id - Type: string. Desc: parent post id if action is performed on comment or reply. otherwise null
 *
 * post_id - Type: string. Desc: post_id guid (only from post / comment. if not from post send null)
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment (only from post / comment. if not from post send null)
 *
 * visitor_id - Type: guid.
 * @param {actionButtonActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonActionClick = function (params) {
    return { evid: 526, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} archiveEventNotInUse522Params
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: archive event - not in use. Evid: 522.
 * Event description: archive event - not in use.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {archiveEventNotInUse522Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var archiveEventNotInUse522 = function (params) {
    return { evid: 522, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} searchPageSearchTabClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {string} tab_name - posts, members
* @property {GUID} visitor_id - null
**/
/**
 * Name: search page -> search tab click. Evid: 536.
 * Event description: Event triggered when clicking on tabs in search.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * tab_name - Type: string. Desc: posts, members
 *
 * visitor_id - Type: guid.
 * @param {searchPageSearchTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchPageSearchTabClick = function (params) {
    return { evid: 536, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonPopupShareConfirmClickParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} location - popup, post buttom
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - null
* @property {string} post_id - null
* @property {GUID} post_stable_id - null
* @property {string} share_destination - null
* @property {string} type - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> popup share confirm click. Evid: 527.
 * Event description: Event triggered when clicking on one of the 4 options on share popup.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * location - Type: string. Desc: popup, post buttom
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string.
 *
 * post_id - Type: string.
 *
 * post_stable_id - Type: guid.
 *
 * share_destination - Type: string.
 *
 * type - Type: string.
 *
 * visitor_id - Type: guid.
 * @param {actionButtonPopupShareConfirmClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonPopupShareConfirmClick = function (params) {
    return { evid: 527, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} fileUploadSizeLimitReachedParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {number} file_size - size of file in bytes
* @property {string} file_type - file / photo / video
* @property {GUID} instance_id - instance id
* @property {number} limit_value - size limit value in settings in bytes
* @property {string} member_id - member id
* @property {GUID} biToken - metasite id
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment, reply, general
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: File upload size limit reached. Evid: 599.
 * Event description: If a file size limit option is enabled by the site owner, event is triggered when a user tries to upload file reaching the size limit and file uploading stops.

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * file_size - Type: numeric. Desc: size of file in bytes
 *
 * file_type - Type: string. Desc: file / photo / video
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * limit_value - Type: numeric. Desc: size limit value in settings in bytes
 *
 * member_id - Type: string. Desc: member id
 *
 * biToken - Type: guid. Desc: metasite id
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment, reply, general
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {fileUploadSizeLimitReachedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fileUploadSizeLimitReached = function (params) {
    return { evid: 599, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} notificationPageNotificationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} notification_type - like, comment, follow
* @property {string} post_id - post_id guid (will be null for follow notification)
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: notification page -> notification click. Evid: 544.
 * Event description: Event triggered when a user clicking on notification.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * notification_type - Type: string. Desc: like, comment, follow
 *
 * post_id - Type: string. Desc: post_id guid (will be null for follow notification)
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {notificationPageNotificationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationPageNotificationClick = function (params) {
    return { evid: 544, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} followMemberClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {boolean} flag - 0 - not follow / 1 - follow
* @property {GUID} instance_id - null
* @property {string} member_followed - the member_id that had been followed
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - search_results, user_profile
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: follow member click. Evid: 515.
 * Event description: Event triggered when clicking on follow button.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * flag - Type: bool. Desc: 0 - not follow / 1 - follow
 *
 * instance_id - Type: guid.
 *
 * member_followed - Type: string. Desc: the member_id that had been followed
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: search_results, user_profile
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {followMemberClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followMemberClick = function (params) {
    return { evid: 515, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} breadcrumbsClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} current_page_type - feed_page, post_page, user_settings, user_profile, notifications, search_results
* @property {string} destination_page_type - categories_page, feed_page, user_profile
* @property {number} from_position - int (position of the current page in the breadcrumbs)
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {number} to_position - int (position of the destination page in the breadcrumbs)
* @property {GUID} visitor_id - null
**/
/**
 * Name: breadcrumbs click. Evid: 512.
 * Event description: Event triggered when clicking on breadcrumbs.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * current_page_type - Type: string. Desc: feed_page, post_page, user_settings, user_profile, notifications, search_results
 *
 * destination_page_type - Type: string. Desc: categories_page, feed_page, user_profile
 *
 * from_position - Type: numeric. Desc: int (position of the current page in the breadcrumbs)
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * to_position - Type: numeric. Desc: int (position of the destination page in the breadcrumbs)
 *
 * visitor_id - Type: guid.
 * @param {breadcrumbsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbsClick = function (params) {
    return { evid: 512, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} categoriesClickOnCreateBadgeRolePaidPlanParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} button_name - "create" - if create / "edit" - if edit
* @property {string} category_id - current category id
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - settings: "appSettings" / live site: "categoriesManager"
* @property {number} paid_plan_member_count - How many members having selected paid plans got access to category
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussions / questions / all
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Categories - click on Create Badge/Role/PaidPlan. Evid: 592.
 * Event description: When the user clicks on "Create a Badge/Role/Plan"(or Manage Badge/Role/Plan) in the edit category page.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * button_name - Type: string. Desc: "create" - if create / "edit" - if edit
 *
 * category_id - Type: string. Desc: current category id
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings: "appSettings" / live site: "categoriesManager"
 *
 * paid_plan_member_count - Type: numeric. Desc: How many members having selected paid plans got access to category
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussions / questions / all
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {categoriesClickOnCreateBadgeRolePaidPlanParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var categoriesClickOnCreateBadgeRolePaidPlan = function (params) {
    return { evid: 592, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} cogwheelMenuOpenedParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - site guid
* @property {GUID} post_stable_id - null
* @property {string} site_member_id - the member_id after login to Wix forum
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Cogwheel menu opened. Evid: 594.
 * Event description: When a user opens the cogwheel menu in the live site.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: site guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {cogwheelMenuOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cogwheelMenuOpened = function (params) {
    return { evid: 594, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} appFullyLoadedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {boolean} is_disabled_posting - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
* @property {GUID} vsi - vsi
**/
/**
 * Name: App fully loaded. Evid: 704.
 * Event description: This is 4th step out of 4, in the Forum success rate flow:
1. Server gets request (101)
2. Server finished processing request and sends to user (102)
3. User gets the html (103)
4. App fully loaded (704).

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * is_disabled_posting - Type: bool.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 *
 * vsi - Type: guid. Desc: vsi
 * @param {appFullyLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appFullyLoaded = function (params) {
    return { evid: 704, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} forumSettingsSelectLanguageParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} language - Selected language
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - null
**/
/**
 * Name: Forum settings: select language. Evid: 564.
 * Event description: Event trigger when selecting a language in language settings.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * language - Type: string. Desc: Selected language
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid.
 * @param {forumSettingsSelectLanguageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forumSettingsSelectLanguage = function (params) {
    return { evid: 564, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} openCategorySettingsScreenParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} msid - msid
* @property {GUID} biToken - null
* @property {string} origin - "category manager list" / "category three dot action" / "business_manager"
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - "all expanded" / "permissions expanded" / "add_category" / "edit"
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Open category settings screen. Evid: 595.
 * Event description: Event triggered when category settings screen is opened.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: "category manager list" / "category three dot action" / "business_manager"
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: "all expanded" / "permissions expanded" / "add_category" / "edit"
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {openCategorySettingsScreenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openCategorySettingsScreen = function (params) {
    return { evid: 595, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} fileDownloadedParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {string} application_type - Web / OneApp
* @property {string} file_ext - File extension
* @property {string} file_id - The file identifier
* @property {number} file_size - The size of the file being downloaded (in bytes)
* @property {GUID} instance_id - instance id
* @property {string} member_id - member id
* @property {string} mime_type - File type
* @property {GUID} biToken - metasite id
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {boolean} success - 0 - no download link / 1 - download link received
* @property {string} type - post, comment, reply, general
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: file downloaded. Evid: 572.
 * Event description: Event triggered when a person tries to download a file from a forum post, comment or reply..

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * application_type - Type: string. Desc: Web / OneApp
 *
 * file_ext - Type: string. Desc: File extension
 *
 * file_id - Type: string. Desc: The file identifier
 *
 * file_size - Type: numeric. Desc: The size of the file being downloaded (in bytes)
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string. Desc: member id
 *
 * mime_type - Type: string. Desc: File type
 *
 * biToken - Type: guid. Desc: metasite id
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * success - Type: bool. Desc: 0 - no download link / 1 - download link received
 *
 * type - Type: string. Desc: post, comment, reply, general
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {fileDownloadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fileDownloaded = function (params) {
    return { evid: 572, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonDeletePopupConfirmationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> delete popup confirmation click. Evid: 528.
 * Event description: Event triggered when clicking delete on the delete popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonDeletePopupConfirmationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonDeletePopupConfirmationClick = function (params) {
    return { evid: 528, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} emptyStateShownParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id guid
* @property {string} empty_state_type - members_only / specific_members_paid_plans  / specific_members_other / bad_url / no_posts / account_suspended / private_user / all_categories_hidden / log_in_needed
* @property {GUID} instance_id - forum instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site member id
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Empty state shown. Evid: 578.
 * Event description: Event triggered when empty state is shown.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id guid
 *
 * empty_state_type - Type: string. Desc: members_only / specific_members_paid_plans  / specific_members_other / bad_url / no_posts / account_suspended / private_user / all_categories_hidden / log_in_needed
 *
 * instance_id - Type: guid. Desc: forum instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site member id
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {emptyStateShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var emptyStateShown = function (params) {
    return { evid: 578, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} mentionsSuggestionsListOpenedParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {string} application_type - Web/OneApp
* @property {GUID} instance_id - instance id
* @property {string} list_source - keyboard or button
* @property {string} member_id - member id
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - comment/ reply/post
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: mentions suggestions list opened. Evid: 574.
 * Event description: When a user added '@' from top bar or from keyboard and the suggestions list opened.

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * application_type - Type: string. Desc: Web/OneApp
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * list_source - Type: string. Desc: keyboard or button
 *
 * member_id - Type: string. Desc: member id
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: comment/ reply/post
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {mentionsSuggestionsListOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mentionsSuggestionsListOpened = function (params) {
    return { evid: 574, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickOnCategoryParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} category_id - category_id guid
* @property {string} category_slug - category_slug
* @property {string} catgory_name - catgory_slug
* @property {GUID} instance_id - null
* @property {string} main_display_type - list_of_posts / list_of_categories
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - categories_page, dropdown (dropdown is for mobile), post_sidebar, post_category_indication (in OneApp)
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: click on category. Evid: 502.
 * Event description: Event triggered when category is clicked.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * category_id - Type: string. Desc: category_id guid
 *
 * category_slug - Type: string. Desc: category_slug
 *
 * catgory_name - Type: string. Desc: catgory_slug
 *
 * instance_id - Type: guid.
 *
 * main_display_type - Type: string. Desc: list_of_posts / list_of_categories
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_page, dropdown (dropdown is for mobile), post_sidebar, post_category_indication (in OneApp)
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {clickOnCategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnCategory = function (params) {
    return { evid: 502, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} mainPageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {boolean} is_disabled_posting - True / False
* @property {string} main_display_type - list_of_posts / list_of_categories / list_of_my_posts
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - msid
* @property {string} origin - wix_site, external_link (url, google), breadcrumbs, list_icon (list_icon is from mobile only (hamburger icon)), post_sidebar, oneapp_tab, dropdown (dropdown is for mobile), widget, categories_tab, all_posts_tab, my_posts_tab, dashboard_activity_widget
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: main page opened. Evid: 501.
 * Event description: Event triggered when categories (main) page opened.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * is_disabled_posting - Type: bool. Desc: True / False
 *
 * main_display_type - Type: string. Desc: list_of_posts / list_of_categories / list_of_my_posts
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: wix_site, external_link (url, google), breadcrumbs, list_icon (list_icon is from mobile only (hamburger icon)), post_sidebar, oneapp_tab, dropdown (dropdown is for mobile), widget, categories_tab, all_posts_tab, my_posts_tab, dashboard_activity_widget
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {mainPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mainPageOpened = function (params) {
    return { evid: 501, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} markAsBestClickParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} comment_id - comment id that has been marked
* @property {boolean} flag - 0 - unmark as best / 1 - mark as best
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - metasite id
* @property {string} origin - post_page, hover_box
* @property {string} post_id - parent of the comment that has been marked as best
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Mark as best click. Evid: 597.
 * Event description: Event triggered when clicking on mark as best on an answer.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * comment_id - Type: string. Desc: comment id that has been marked
 *
 * flag - Type: bool. Desc: 0 - unmark as best / 1 - mark as best
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: post_page, hover_box
 *
 * post_id - Type: string. Desc: parent of the comment that has been marked as best
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {markAsBestClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var markAsBestClick = function (params) {
    return { evid: 597, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonDeletePopupCancelClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> delete popup cancel click. Evid: 532.
 * Event description: Event triggered when clicking cancel on the delete popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonDeletePopupCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonDeletePopupCancelClick = function (params) {
    return { evid: 532, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} followCategoryClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} category_followed - the category_id that had been followed
* @property {boolean} flag - 0 - not follow / 1 - follow
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - search_results, user_profile
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question / all
* @property {string} type - 'follow' /'following'/'unfollow'
* @property {GUID} visitor_id - null
**/
/**
 * Name: follow/unfollow category success. Evid: 554.
 * Event description: Event triggered when clicking on follow category button.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * category_followed - Type: string. Desc: the category_id that had been followed
 *
 * flag - Type: bool. Desc: 0 - not follow / 1 - follow
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: search_results, user_profile
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question / all
 *
 * type - Type: string. Desc: 'follow' /'following'/'unfollow'
 *
 * visitor_id - Type: guid.
 * @param {followCategoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followCategoryClick = function (params) {
    return { evid: 554, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editingPostWindowPublishPostClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: editing post window -> publish post click. Evid: 508.
 * Event description: event triggered when a user click on publish in the post edit window. event is also relevant for new posts! not just edit.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {editingPostWindowPublishPostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editingPostWindowPublishPostClick = function (params) {
    return { evid: 508, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} archiveEventNotInUse549Params
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} bar_location - login_bar, breadcrumbs
* @property {GUID} instance_id - null
* @property {string} member_id - member_id
* @property {GUID} biToken - null
* @property {number} num_of_notification_bubble - int (the number of notification on the notification bubble once you clicked on it)
* @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: archive event - not in use. Evid: 549.
 * Event description: archive event - not in use.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * bar_location - Type: string. Desc: login_bar, breadcrumbs
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: member_id
 *
 * biToken - Type: guid.
 *
 * num_of_notification_bubble - Type: numeric. Desc: int (the number of notification on the notification bubble once you clicked on it)
 *
 * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {archiveEventNotInUse549Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var archiveEventNotInUse549 = function (params) {
    return { evid: 549, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} settingsPageSettingsClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {boolean} flag - 0 - off / 1 - on
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {string} settings_type - (Email_likes, email_comments, email_subscriptions, push_likes, push_comments, push_subscriptions)
* @property {GUID} visitor_id - null
**/
/**
 * Name: settings page -> settings click. Evid: 546.
 * Event description: Event trigger when changing the toggles.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * flag - Type: bool. Desc: 0 - off / 1 - on
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * settings_type - Type: string. Desc: (Email_likes, email_comments, email_subscriptions, push_likes, push_comments, push_subscriptions)
 *
 * visitor_id - Type: guid.
 * @param {settingsPageSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsPageSettingsClick = function (params) {
    return { evid: 546, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} notificationPageNotificationPageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: notification page -> notification page opened. Evid: 543.
 * Event description: Event triggered when the notification page opens.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {notificationPageNotificationPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationPageNotificationPageOpened = function (params) {
    return { evid: 543, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonAddModeratorPopupCancelClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> add moderator popup cancel click. Evid: 583.
 * Event description: Event triggered when clicking confirm in the popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonAddModeratorPopupCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonAddModeratorPopupCancelClick = function (params) {
    return { evid: 583, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editUserCoverPhotoChangedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit user -> cover photo changed. Evid: 541.
 * Event description: Event triggered after changing cover image.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editUserCoverPhotoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editUserCoverPhotoChanged = function (params) {
    return { evid: 541, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postListOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} category_id - category_id guid
* @property {string} category_name - category_slug
* @property {string} category_slug - category_slug
* @property {GUID} instance_id - null
* @property {string} main_display_type - list_of_posts / list_of_categories
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - categories_page, external_link (url, google), breadcrumbs, wix_site, post_sidebar, business_manager, post_category_indication(oneApp)
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {number} total_pages - how many pages with posts (in case there are more 20 posts)
* @property {number} total_posts - how many posts category has
* @property {GUID} visitor_id - null
**/
/**
 * Name: post list opened. Evid: 503.
 * Event description: Event triggered when forum post list is opened (contents of a category).

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * category_id - Type: string. Desc: category_id guid
 *
 * category_name - Type: string. Desc: category_slug
 *
 * category_slug - Type: string. Desc: category_slug
 *
 * instance_id - Type: guid.
 *
 * main_display_type - Type: string. Desc: list_of_posts / list_of_categories
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_page, external_link (url, google), breadcrumbs, wix_site, post_sidebar, business_manager, post_category_indication(oneApp)
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * total_pages - Type: numeric. Desc: how many pages with posts (in case there are more 20 posts)
 *
 * total_posts - Type: numeric. Desc: how many posts category has
 *
 * visitor_id - Type: guid.
 * @param {postListOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postListOpened = function (params) {
    return { evid: 503, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonAddModeratorPopupConfirmationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> add moderator popup confirmation click. Evid: 582.
 * Event description: Event triggered when clicking confirm in the popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonAddModeratorPopupConfirmationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonAddModeratorPopupConfirmationClick = function (params) {
    return { evid: 582, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} sortClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - feed_page, user_profile
* @property {GUID} post_stable_id - null
* @property {string} sort_by - (views, comments, loves, date, null for cards)
* @property {GUID} visitor_id - null
**/
/**
 * Name: sort click. Evid: 504.
 * Event description: Event triggered when sorting posts.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, user_profile
 *
 * post_stable_id - Type: guid.
 *
 * sort_by - Type: string. Desc: (views, comments, loves, date, null for cards)
 *
 * visitor_id - Type: guid.
 * @param {sortClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sortClick = function (params) {
    return { evid: 504, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} likePublishedParams
* @property {string} action - add (used for new ones reaction added), replace, remove
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {boolean} flag - 0 - unliked / 1 - like
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - feed_page, post_page, search_results, user_profile
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} reaction_type - reaction_type
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post
* @property {GUID} visitor_id - null
**/
/**
 * Name: like published. Evid: 521.
 * Event description: Event triggered after registering like.

 * action - Type: string. Desc: add (used for new ones reaction added), replace, remove
 *
 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * flag - Type: bool. Desc: 0 - unliked / 1 - like
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * reaction_type - Type: string. Desc: reaction_type
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post
 *
 * visitor_id - Type: guid.
 * @param {likePublishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var likePublished = function (params) {
    return { evid: 521, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} newPostSubmittedForApprovalParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id
* @property {number} file_count - Number of files attached to a post
* @property {boolean} has_emoji - 0 - no emoji / 1 - with emoji
* @property {boolean} has_gallery - 0 - no gallery, 1 - with gallery
* @property {boolean} has_gif - 0 - no gif / 1 - has gif
* @property {boolean} has_hashtag - 0 - no hashtag / 1 - has hashtag
* @property {boolean} has_image - null
* @property {boolean} has_mention - 0 - no mention / 1 - with mention
* @property {boolean} has_poll - 0 - no poll / 1 - with poll
* @property {boolean} has_quote - 0 - no quote / 1 - with quote
* @property {boolean} has_video - 0 - no video/ 1 - with video
* @property {number} hashtag_count - the number of hashtags in post
* @property {number} image_count - the number of images in the post
* @property {number} image_in_gallery_count - the number of images in gallery
* @property {GUID} instance_id - null
* @property {boolean} is_custom_video - 0 - no custom video / 1 - has video uploaded through video upload
* @property {string} media_source - "file"(when uploading file in web) / "gallery"(when uploading file from oneApp ) / "camera" (for oneApp)  / "link" (adding video using link in Web)
* @property {string} member_id - null
* @property {number} mention_count - the number of mentions in post
* @property {GUID} msid - site msid
* @property {GUID} biToken - null
* @property {string} origin - WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post,  / business_manager
* @property {string} post_id - post guid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: New Post submitted for approval. Evid: 711.
 * Event description: Event triggered after post is submitted for approval.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id
 *
 * file_count - Type: numeric. Desc: Number of files attached to a post
 *
 * has_emoji - Type: bool. Desc: 0 - no emoji / 1 - with emoji
 *
 * has_gallery - Type: bool. Desc: 0 - no gallery, 1 - with gallery
 *
 * has_gif - Type: bool. Desc: 0 - no gif / 1 - has gif
 *
 * has_hashtag - Type: bool. Desc: 0 - no hashtag / 1 - has hashtag
 *
 * has_image - Type: bool.
 *
 * has_mention - Type: bool. Desc: 0 - no mention / 1 - with mention
 *
 * has_poll - Type: bool. Desc: 0 - no poll / 1 - with poll
 *
 * has_quote - Type: bool. Desc: 0 - no quote / 1 - with quote
 *
 * has_video - Type: bool. Desc: 0 - no video/ 1 - with video
 *
 * hashtag_count - Type: numeric. Desc: the number of hashtags in post
 *
 * image_count - Type: numeric. Desc: the number of images in the post
 *
 * image_in_gallery_count - Type: numeric. Desc: the number of images in gallery
 *
 * instance_id - Type: guid.
 *
 * is_custom_video - Type: bool. Desc: 0 - no custom video / 1 - has video uploaded through video upload
 *
 * media_source - Type: string. Desc: "file"(when uploading file in web) / "gallery"(when uploading file from oneApp ) / "camera" (for oneApp)  / "link" (adding video using link in Web)
 *
 * member_id - Type: string.
 *
 * mention_count - Type: numeric. Desc: the number of mentions in post
 *
 * msid - Type: guid. Desc: site msid
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post,  / business_manager
 *
 * post_id - Type: string. Desc: post guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {newPostSubmittedForApprovalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var newPostSubmittedForApproval = function (params) {
    return { evid: 711, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} archiveEventNotInUse550Params
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {boolean} is_moderator - 0 - not moderator / 1 - moderator
* @property {string} login_method - email, facebook, google
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: archive event - not in use. Evid: 550.
 * Event description: archive event - not in use.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * is_moderator - Type: bool. Desc: 0 - not moderator / 1 - moderator
 *
 * login_method - Type: string. Desc: email, facebook, google
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {archiveEventNotInUse550Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var archiveEventNotInUse550 = function (params) {
    return { evid: 550, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editingPostWindowTextEditorOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: editing post window -> text editor opened. Evid: 509.
 * Event description: Event triggered when text editor opens (post & comment text editing toolbar). event is also relevant for new posts! not just edit.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {editingPostWindowTextEditorOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editingPostWindowTextEditorOpened = function (params) {
    return { evid: 509, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} createPostClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} button_position - top, bottom - (bottom only for classic)
* @property {string} cta_origin - main_page; category
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - Web: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category / business_manager, dashboard_activity_widget; WixApp: live / plus_button / business_manager
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question
* @property {GUID} visitor_id - null
**/
/**
 * Name: create post click. Evid: 505.
 * Event description: Event triggered when clicking on create new post button.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * button_position - Type: string. Desc: top, bottom - (bottom only for classic)
 *
 * cta_origin - Type: string. Desc: main_page; category
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: Web: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category / business_manager, dashboard_activity_widget; WixApp: live / plus_button / business_manager
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question
 *
 * visitor_id - Type: guid.
 * @param {createPostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var createPostClick = function (params) {
    return { evid: 505, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonLogInSignUpParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {string} type - login/signup
* @property {GUID} visitor_id - null
**/
/**
 * Name: log in / sign up to comment. Evid: 568.
 * Event description: Event triggered when clicking on sign up or login in in post page.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: login/signup
 *
 * visitor_id - Type: guid.
 * @param {actionButtonLogInSignUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonLogInSignUp = function (params) {
    return { evid: 568, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} upvoteDownvoteClickParams
* @property {string} action_type - vote / unvote /downvote / undownvote
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {number} final_state - final value of counter after click/action
* @property {GUID} instance_id - instance id
* @property {boolean} is_best_answer - If comment is marked as best answer
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - msid
* @property {string} origin - feed_page, post_page, search_results, user_profile
* @property {string} post_id - post_id guid (comment id in this case)
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: upvote/downvote click. Evid: 590.
 * Event description: Event triggered after clicking on Upvote/Downvote button.

 * action_type - Type: string. Desc: vote / unvote /downvote / undownvote
 *
 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * final_state - Type: numeric. Desc: final value of counter after click/action
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * is_best_answer - Type: bool. Desc: If comment is marked as best answer
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
 *
 * post_id - Type: string. Desc: post_id guid (comment id in this case)
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {upvoteDownvoteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upvoteDownvoteClick = function (params) {
    return { evid: 590, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} followersPageOpenedParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - feed_page, user_profile
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: followers page opened. Evid: 561.
 * Event description: Event triggered when followers page is opened.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, user_profile
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {followersPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followersPageOpened = function (params) {
    return { evid: 561, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickOnSearchFieldParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - search_results, post_page, post_edit_page,
feed_page, categories_page, create_post, categories_tab, all_posts_tab, my_posts_tab
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: click on search field. Evid: 98.
 * Event description: Event triggered when UoU/User clicks on search field.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: search_results, post_page, post_edit_page,
feed_page, categories_page, create_post, categories_tab, all_posts_tab, my_posts_tab
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {clickOnSearchFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnSearchField = function (params) {
    return { evid: 98, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonOpenActionsParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} application_type - OneApp / Web
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - feed_page, inner_page, search, user_profile, business_manager
* @property {string} post_id - post_id guid (only from post / comment. if not from post send null)
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment (only from post / comment. if not from post send null)
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> open actions. Evid: 524.
 * Event description: Event triggered after you click on 3 dots.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * application_type - Type: string. Desc: OneApp / Web
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, inner_page, search, user_profile, business_manager
 *
 * post_id - Type: string. Desc: post_id guid (only from post / comment. if not from post send null)
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment (only from post / comment. if not from post send null)
 *
 * visitor_id - Type: guid.
 * @param {actionButtonOpenActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonOpenActions = function (params) {
    return { evid: 524, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} shownGuidelinesParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category_id
* @property {GUID} instance_id - Forum instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - on_category_change (guideline is shown when another Category is chosen); create_post (guideline is shown when site member click 'Create new post'; edit (guideline is shown when site member clicks 'edit' post
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - forum_guidelines; category_guidelines
* @property {GUID} visitor_id - null
**/
/**
 * Name: Shown Guidelines. Evid: 88.
 * Event description: Event triggered when Forum/Category guidelines are shown to site member.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category_id
 *
 * instance_id - Type: guid. Desc: Forum instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_category_change (guideline is shown when another Category is chosen); create_post (guideline is shown when site member click 'Create new post'; edit (guideline is shown when site member clicks 'edit' post
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: forum_guidelines; category_guidelines
 *
 * visitor_id - Type: guid.
 * @param {shownGuidelinesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shownGuidelines = function (params) {
    return { evid: 88, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} readOnlyMessageShownParams
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} option_value - only for step=2 : make_active / stay_read_only
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} step - null
* @property {GUID} uuid - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Read Only message shown. Evid: 100.
 * Event description: Event triggered when Read Only message is shown to user. (step = 1)
Event triggered when user clicks the button to make forum active or stay read only (step = 2).

 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * option_value - Type: string. Desc: only for step=2 : make_active / stay_read_only
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * step - Type: string.
 *
 * uuid - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {readOnlyMessageShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var readOnlyMessageShown = function (params) {
    return { evid: 100, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editPostImageFinishUploadingParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - image type - cover, avatar, post editor
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit post -> Image finish uploading. Evid: 552.
 * Event description: event triggered when a user finish to upload Image (comes together with Image start uploading for success rate).

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: image type - cover, avatar, post editor
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editPostImageFinishUploadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editPostImageFinishUploading = function (params) {
    return { evid: 552, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postApprovalModalWindowOpenParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id guid
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} msid - msid
* @property {GUID} biToken - null
* @property {string} post_id - new post id
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Post approval modal window open. Evid: 712.
 * Event description: Event triggered when Post submitted for approval and modal window opens.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id guid
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: new post id
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {postApprovalModalWindowOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postApprovalModalWindowOpen = function (params) {
    return { evid: 712, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} settingsPageSettingsPageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: settings page -> settings page opened. Evid: 545.
 * Event description: Event trigger when setting page opens.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {settingsPageSettingsPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsPageSettingsPageOpened = function (params) {
    return { evid: 545, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} followingPageOpenedParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {string} origin - feed_page, user_profile
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: following page opened. Evid: 562.
 * Event description: Event triggered when following page is opened.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, user_profile
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {followingPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followingPageOpened = function (params) {
    return { evid: 562, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} captchaOnPostPublishParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {number} captcha_step - 1 - shown to user / 2 - solved (successfully or not )
* @property {boolean} captcha_success - for captcha _step = 2 : 1 - success / 0 - failure
* @property {string} category_id - category_id guid if available
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {string} postType - "post" / "comment"
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Captcha on post publish. Evid: 89.
 * Event description: Event is triggered when captcha is shown to UoU and when he solves captcha.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * captcha_step - Type: numeric. Desc: 1 - shown to user / 2 - solved (successfully or not )
 *
 * captcha_success - Type: bool. Desc: for captcha _step = 2 : 1 - success / 0 - failure
 *
 * category_id - Type: string. Desc: category_id guid if available
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * postType - Type: string. Desc: "post" / "comment"
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {captchaOnPostPublishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var captchaOnPostPublish = function (params) {
    return { evid: 89, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} categoriesCategoryDeletedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} applicationType - OneApp / Web
* @property {string} category_access - everyone / members_only / selected_members
* @property {string} category_id - category guid
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} name - name of the category
* @property {string} origin - settings (value: appSettings) / live site (value:categoriesManager)
* @property {string} place - unused
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question / all
* @property {GUID} site_member_id - site_member_id
* @property {string} type - category/subcategory
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Categories - category deleted. Evid: 34.
 * Event description: When a category is deleted successfully.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * applicationType - Type: string. Desc: OneApp / Web
 *
 * category_access - Type: string. Desc: everyone / members_only / selected_members
 *
 * category_id - Type: string. Desc: category guid
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the category
 *
 * origin - Type: string. Desc: settings (value: appSettings) / live site (value:categoriesManager)
 *
 * place - Type: string. Desc: unused
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question / all
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: category/subcategory
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {categoriesCategoryDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var categoriesCategoryDeleted = function (params) {
    return { evid: 34, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} selectACategoryClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - null
* @property {string} category_id - category_id guid
* @property {boolean} flag - 1 - got warning message before selecting category / 0 - chose a category before press publish
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post, live_create_post
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Select a category click. Evid: 706.
 * Event description: Event triggered when user/site member chooses category from category list in 'Select a category' place while writing a post..

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category_id guid
 *
 * flag - Type: bool. Desc: 1 - got warning message before selecting category / 0 - chose a category before press publish
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post, live_create_post
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {selectACategoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectACategoryClick = function (params) {
    return { evid: 706, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editUserEditProfilePageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit user -> edit profile page opened. Evid: 539.
 * Event description: Event triggered when edit profile page opened.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editUserEditProfilePageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editUserEditProfilePageOpened = function (params) {
    return { evid: 539, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editUserAvatarChangeClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit user -> avatar change click. Evid: 556.
 * Event description: Event triggered after clicking on changing avatar. this is the 'try' event of 540..

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editUserAvatarChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editUserAvatarChangeClick = function (params) {
    return { evid: 556, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} searchPageSearchPageOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} application_type - OneApp/Web
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: search page -> search page opened. Evid: 535.
 * Event description: Event triggered when the search page opens.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * application_type - Type: string. Desc: OneApp/Web
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {searchPageSearchPageOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchPageSearchPageOpened = function (params) {
    return { evid: 535, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickOnPostCommentParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - feed_page, search
* @property {string} post_id - post_id guid
* @property {string} post_slug - post_slug
* @property {GUID} post_stable_id - null
* @property {string} post_title - post_slug
* @property {string} search_term - null if didnt come from search
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: click on post comment. Evid: 518.
 * Event description: Event triggered when clicking on comments icon from feed page, or on a comment from search results.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, search
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_slug - Type: string. Desc: post_slug
 *
 * post_stable_id - Type: guid.
 *
 * post_title - Type: string. Desc: post_slug
 *
 * search_term - Type: string. Desc: null if didnt come from search
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {clickOnPostCommentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnPostComment = function (params) {
    return { evid: 518, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postApprovalModalWindowClosedParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id guid
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} msid - msid
* @property {GUID} biToken - null
* @property {string} origin - "X", "OK"
* @property {string} post_id - new post id
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Post approval modal window closed. Evid: 713.
 * Event description: Event triggered when closes modal window.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id guid
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: "X", "OK"
 *
 * post_id - Type: string. Desc: new post id
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {postApprovalModalWindowClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postApprovalModalWindowClosed = function (params) {
    return { evid: 713, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editPostPostEditingWindowOpenedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: post editing window opened. Evid: 506.
 * Event description: event triggered when user create a new post.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid.
 * @param {editPostPostEditingWindowOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editPostPostEditingWindowOpened = function (params) {
    return { evid: 506, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} forumTabClickParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} bi_token - msid
* @property {GUID} biToken - null
* @property {string} origin - "categories_tab", "all_posts_tab", "my_posts_tab", "create_post_page", "post_edit_page" , "categories_page", "post_page"
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} tab_name - categories; all_posts; my_posts
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Forum tab click. Evid: 97.
 * Event description: Tab click in Forum live.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * bi_token - Type: guid. Desc: msid
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: "categories_tab", "all_posts_tab", "my_posts_tab", "create_post_page", "post_edit_page" , "categories_page", "post_page"
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * tab_name - Type: string. Desc: categories; all_posts; my_posts
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {forumTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forumTabClick = function (params) {
    return { evid: 97, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonPinPostConfirmationClickParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} msid - site msid
* @property {GUID} biToken - null
* @property {string} origin - post_list / post_page
* @property {string} post_id - post guid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} value - 1day, 1week, 1month, infinitely
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: action button -> pin post (confirmation click). Evid: 707.
 * Event description: Event triggered when clicking on "Pin Post" with one of 4 possible duration options (1day, 1week, 1month, infinitely).

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * msid - Type: guid. Desc: site msid
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: post_list / post_page
 *
 * post_id - Type: string. Desc: post guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * value - Type: string. Desc: 1day, 1week, 1month, infinitely
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {actionButtonPinPostConfirmationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonPinPostConfirmationClick = function (params) {
    return { evid: 707, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postLimitReachedParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {string} application_type - Web / OneApp
* @property {GUID} instance_id - instance id
* @property {string} member_id - member id
* @property {GUID} biToken - metasite id
* @property {number} post_limit - post limit set by the site owner (1, 5, 10)
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment, reply, general
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: post limit reached. Evid: 576.
 * Event description: If a limit option is set by the site owner, event is triggered when a new member (registered for no longer than a week) tries post in a forum after reaching the limit.

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * application_type - Type: string. Desc: Web / OneApp
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string. Desc: member id
 *
 * biToken - Type: guid. Desc: metasite id
 *
 * post_limit - Type: numeric. Desc: post limit set by the site owner (1, 5, 10)
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment, reply, general
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {postLimitReachedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postLimitReached = function (params) {
    return { evid: 576, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} attemptToPublishPostParams
* @property {GUID} app_id -
* @property {GUID} app_site_id - null
* @property {string} attempt_type - new/edit. `edit` value fires when user edit comment/reply
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} parent_post_id - parent post/question guid for comment, reply. Null if initial post.
* @property {string} post_id - post id
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question
* @property {GUID} site_member_id - site_member_id
* @property {number} symbol_count - the amount on text symbols in the comment/reply
* @property {string} type - comment, reply
* @property {GUID} uuid - user guid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: attempt to publish comment/reply. Evid: 587.
 * Event description: Happens when a user/member/visitor attempts to publish (clicks "publish") a comment/reply.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * attempt_type - Type: string. Desc: new/edit. `edit` value fires when user edit comment/reply
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * parent_post_id - Type: string. Desc: parent post/question guid for comment, reply. Null if initial post.
 *
 * post_id - Type: string. Desc: post id
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * symbol_count - Type: numeric. Desc: the amount on text symbols in the comment/reply
 *
 * type - Type: string. Desc: comment, reply
 *
 * uuid - Type: guid. Desc: user guid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {attemptToPublishPostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var attemptToPublishPost = function (params) {
    return { evid: 587, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} markAllPostsAsSeenParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - site msid
* @property {string} origin - "posts_list"
* @property {GUID} post_stable_id - null
* @property {number} posts_count - number of post became "seen"
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: mark all posts as seen. Evid: 603.
 * Event description: Event is triggered when clicking on the "mark all posts as seen" button.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: site msid
 *
 * origin - Type: string. Desc: "posts_list"
 *
 * post_stable_id - Type: guid.
 *
 * posts_count - Type: numeric. Desc: number of post became "seen"
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {markAllPostsAsSeenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var markAllPostsAsSeen = function (params) {
    return { evid: 603, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonRemoveModeratorPopupCancelClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> remove moderator popup cancel click. Evid: 581.
 * Event description: Event triggered when clicking cancel in the popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonRemoveModeratorPopupCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonRemoveModeratorPopupCancelClick = function (params) {
    return { evid: 581, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} chooseACategoryWarningParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance_id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post, live_create_post
* @property {GUID} post_stable_id - null
* @property {string} post_title - post title
* @property {GUID} site_member_id - site_member_id
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Choose a category warning. Evid: 705.
 * Event description: Event triggered after site member press publish in post creation modal with no category chosen from 'Select a category'. This should fire only first time red sign appears next to 'Select a category'..

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: WEB: live_categories_tab, live_all_posts_tab, live_my_posts_tab, live_category, live_edit_post, live_create_post
 *
 * post_stable_id - Type: guid.
 *
 * post_title - Type: string. Desc: post title
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {chooseACategoryWarningParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var chooseACategoryWarning = function (params) {
    return { evid: 705, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonCloseActionsParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - instance_id
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - msid
* @property {string} origin - business_manager
* @property {string} post_ids - post ids (CSV)
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question / all
* @property {GUID} site_member_id - site member id
* @property {GUID} visitor_id - null
**/
/**
 * Name: deleted event. Evid: 525.
 * Event description: deleted event placeholder.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: business_manager
 *
 * post_ids - Type: string. Desc: post ids (CSV)
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question / all
 *
 * site_member_id - Type: guid. Desc: site member id
 *
 * visitor_id - Type: guid.
 * @param {actionButtonCloseActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonCloseActions = function (params) {
    return { evid: 525, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} toggleAutoSuggestParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id where the post is being started from
* @property {boolean} flag - 0 - toggle off / 1 - toggle on
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - metasite id
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Toggle Auto Suggest. Evid: 598.
 * Event description: Event triggered when a visitor toggles auto suggest feature on or off.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id where the post is being started from
 *
 * flag - Type: bool. Desc: 0 - toggle off / 1 - toggle on
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: metasite id
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {toggleAutoSuggestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toggleAutoSuggest = function (params) {
    return { evid: 598, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} searchFocusParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: search focus. Evid: 510.
 * Event description: Event triggered when focusing on search.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {searchFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchFocus = function (params) {
    return { evid: 510, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} reportPostParams
* @property {string} action - "offensive_content" / "offensive_media" / "spam"
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - feed_page, post_page
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Report post. Evid: 600.
 * Event description: Event triggered when user reports offensive content or spam.

 * action - Type: string. Desc: "offensive_content" / "offensive_media" / "spam"
 *
 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: feed_page, post_page
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {reportPostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reportPost = function (params) {
    return { evid: 600, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} paginationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} button_type - button_type
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - feed_page, post_page, search, business_manager, member_posts_page, member_comments_page
* @property {string} page_destination - (1,2...,previous,next) - string
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site member id
* @property {GUID} visitor_id - null
**/
/**
 * Name: pagination click. Evid: 519.
 * Event description: Event triggered when you click on pagination (move between pages - numbers, back, forward).

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * button_type - Type: string. Desc: button_type
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: feed_page, post_page, search, business_manager, member_posts_page, member_comments_page
 *
 * page_destination - Type: string. Desc: (1,2...,previous,next) - string
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site member id
 *
 * visitor_id - Type: guid.
 * @param {paginationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var paginationClick = function (params) {
    return { evid: 519, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} mentionSuggestionsMemberSelectedParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {string} application_type - Web/OneApp
* @property {GUID} instance_id - instance id
* @property {string} member_id - member id
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - comment/ reply/post
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: mention suggestions member selected. Evid: 575.
 * Event description: When a user clicks one user from the mentioned list.

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * application_type - Type: string. Desc: Web/OneApp
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string. Desc: member id
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: comment/ reply/post
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {mentionSuggestionsMemberSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mentionSuggestionsMemberSelected = function (params) {
    return { evid: 575, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} fileUploadedParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {string} application_type - Web / OneApp
* @property {string} file_ext - File extension
* @property {string} file_id - The file identifier (null if not successful)
* @property {number} file_size - The size of the file being uploaded (in bytes)
* @property {GUID} instance_id - instance id
* @property {string} member_id - member id
* @property {string} mime_type - File type
* @property {GUID} biToken - metasite id
* @property {string} origin - live / business_manager
* @property {GUID} post_stable_id - null
* @property {boolean} success - 0 - upload failed / 1 - upload successful
* @property {string} type - post, comment, reply, general
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: file uploaded. Evid: 571.
 * Event description: Event triggered when a person tries to upload a file to a forum post, comment or reply (Only files within the size limit trigger the event).

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * application_type - Type: string. Desc: Web / OneApp
 *
 * file_ext - Type: string. Desc: File extension
 *
 * file_id - Type: string. Desc: The file identifier (null if not successful)
 *
 * file_size - Type: numeric. Desc: The size of the file being uploaded (in bytes)
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string. Desc: member id
 *
 * mime_type - Type: string. Desc: File type
 *
 * biToken - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: live / business_manager
 *
 * post_stable_id - Type: guid.
 *
 * success - Type: bool. Desc: 0 - upload failed / 1 - upload successful
 *
 * type - Type: string. Desc: post, comment, reply, general
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {fileUploadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fileUploaded = function (params) {
    return { evid: 571, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} followPostClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {boolean} flag - 0 - not follow / 1 - follow
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - search_results, user_profile, post_sidebar, feed_page, post_page
* @property {string} post_followed - the post_id that had been followed
* @property {GUID} post_stable_id - null
* @property {string} posts_format - discussion / question / all
* @property {GUID} visitor_id - null
**/
/**
 * Name: follow post click. Evid: 553.
 * Event description: Event triggered when clicking on follow post button.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * flag - Type: bool. Desc: 0 - not follow / 1 - follow
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: search_results, user_profile, post_sidebar, feed_page, post_page
 *
 * post_followed - Type: string. Desc: the post_id that had been followed
 *
 * post_stable_id - Type: guid.
 *
 * posts_format - Type: string. Desc: discussion / question / all
 *
 * visitor_id - Type: guid.
 * @param {followPostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followPostClick = function (params) {
    return { evid: 553, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} searchResultsParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {string} application_type - null
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - categories_tab, feed_page, post_page, user_settings, user_profile, notifications, search_results, my_posts_tab, all_posts_tab
* @property {GUID} post_stable_id - null
* @property {string} referral_info - direct
* @property {number} result_count_members - int
* @property {number} result_count_posts - int
* @property {string} search_term - what the user typed
* @property {GUID} visitor_id - null
**/
/**
 * Name: search results. Evid: 511.
 * Event description: Event triggered when search results page renders.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * application_type - Type: string.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_tab, feed_page, post_page, user_settings, user_profile, notifications, search_results, my_posts_tab, all_posts_tab
 *
 * post_stable_id - Type: guid.
 *
 * referral_info - Type: string. Desc: direct
 *
 * result_count_members - Type: numeric. Desc: int
 *
 * result_count_posts - Type: numeric. Desc: int
 *
 * search_term - Type: string. Desc: what the user typed
 *
 * visitor_id - Type: guid.
 * @param {searchResultsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchResults = function (params) {
    return { evid: 511, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} actionButtonMoveCategoryPopupConfirmationClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} type - post, comment
* @property {GUID} visitor_id - null
**/
/**
 * Name: action button -> move category popup confirmation click. Evid: 530.
 * Event description: Event triggered when clicking move on move to popup.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: post, comment
 *
 * visitor_id - Type: guid.
 * @param {actionButtonMoveCategoryPopupConfirmationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionButtonMoveCategoryPopupConfirmationClick = function (params) {
    return { evid: 530, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} forumSettingsCustomizePostToolbarParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} feature - image/gallery/video/divider/HTML/emoji
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {string} type - on/off
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - null
**/
/**
 * Name: Forum settings: customize post toolbar. Evid: 565.
 * Event description: Event triggered after switching toggl.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * feature - Type: string. Desc: image/gallery/video/divider/HTML/emoji
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * type - Type: string. Desc: on/off
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid.
 * @param {forumSettingsCustomizePostToolbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forumSettingsCustomizePostToolbar = function (params) {
    return { evid: 565, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} moveCategoryUpDownParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} applicationType - OneApp / Web
* @property {string} category_id - category id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} subcategory_id - subcategory id
* @property {string} type - post, comment
* @property {string} type_chosen - down/up
* @property {GUID} visitor_id - null
**/
/**
 * Name: move category up/down. Evid: 567.
 * Event description: Event triggered when clicking move category down/up.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * applicationType - Type: string. Desc: OneApp / Web
 *
 * category_id - Type: string. Desc: category id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * subcategory_id - Type: guid. Desc: subcategory id
 *
 * type - Type: string. Desc: post, comment
 *
 * type_chosen - Type: string. Desc: down/up
 *
 * visitor_id - Type: guid.
 * @param {moveCategoryUpDownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var moveCategoryUpDown = function (params) {
    return { evid: 567, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} archiveEventNotInUse514Params
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - login_bar_widget, feed_page, post_page, search_results
* @property {GUID} original_instance_id - original_instance_id
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: archive event - not in use. Evid: 514.
 * Event description: archive event - not in use.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: login_bar_widget, feed_page, post_page, search_results
 *
 * original_instance_id - Type: guid. Desc: original_instance_id
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {archiveEventNotInUse514Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var archiveEventNotInUse514 = function (params) {
    return { evid: 514, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickOnPostParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - instance_id
* @property {boolean} is_new - true - post is new / false - post is not new
* @property {boolean} is_read - true - post is already read / false - post was marked as unread
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - msid
* @property {string} origin - feed_page, post_edit_page, categories_page, search_results, create_post, post_page, post_list_item_recent_activity, bm_toast_cta, bm_post_list_title, bm_post_list_cta, widget, search_dropdown, member_posts_page, member_comments_page
* @property {string} post_id - post_id guid
* @property {string} post_name - post_slug
* @property {string} post_slug - post_slug
* @property {GUID} post_stable_id - null
* @property {string} search_term - null if didnt come from search
* @property {GUID} site_member_id - site_member_id
* @property {string} type - post, comment, recent_activity
* @property {GUID} visitor_id - null
**/
/**
 * Name: click on post. Evid: 516.
 * Event description: Event triggered when clicking on a post.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid. Desc: instance_id
 *
 * is_new - Type: bool. Desc: true - post is new / false - post is not new
 *
 * is_read - Type: bool. Desc: true - post is already read / false - post was marked as unread
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: feed_page, post_edit_page, categories_page, search_results, create_post, post_page, post_list_item_recent_activity, bm_toast_cta, bm_post_list_title, bm_post_list_cta, widget, search_dropdown, member_posts_page, member_comments_page
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_name - Type: string. Desc: post_slug
 *
 * post_slug - Type: string. Desc: post_slug
 *
 * post_stable_id - Type: guid.
 *
 * search_term - Type: string. Desc: null if didnt come from search
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: post, comment, recent_activity
 *
 * visitor_id - Type: guid.
 * @param {clickOnPostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnPost = function (params) {
    return { evid: 516, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} mobileBackToCategoriesMenuClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: mobile -> back to categories menu click. Evid: 548.
 * Event description: Event trigger when clicking back on the hamburger icon.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {mobileBackToCategoriesMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileBackToCategoriesMenuClick = function (params) {
    return { evid: 548, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} editUserAvatarChangedParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: edit user -> avatar changed. Evid: 540.
 * Event description: Event triggered after changing avatar.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {editUserAvatarChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editUserAvatarChanged = function (params) {
    return { evid: 540, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postFilterParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {string} category_id - category id
* @property {string} filter_by - discussions / questions / all
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {string} origin - posts_page, filter_and_sort_screen
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: post filter. Evid: 589.
 * Event description: Event triggered when filtering posts in category by type.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * category_id - Type: string. Desc: category id
 *
 * filter_by - Type: string. Desc: discussions / questions / all
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: posts_page, filter_and_sort_screen
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {postFilterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postFilter = function (params) {
    return { evid: 589, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} clickInSearchFieldXParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - null
* @property {GUID} instance_id - null
* @property {string} member_id - null
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Click in Search field "X". Evid: 99.
 * Event description: Event triggered when in search field "X" is clicked.

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {clickInSearchFieldXParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickInSearchFieldX = function (params) {
    return { evid: 99, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} postSortInCategoryParams
* @property {GUID} app_id - null
* @property {GUID} app_site_id - app_site_id
* @property {string} application_type - OneApp / Web
* @property {string} category_id - category id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - posts_page / search
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} sort_by - recent activity / newest / most comments / most viewed / most liked
* @property {GUID} visitor_id - null
**/
/**
 * Name: post sort. Evid: 566.
 * Event description: Event triggered when sorting posts in category.

 * app_id - Type: guid.
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * application_type - Type: string. Desc: OneApp / Web
 *
 * category_id - Type: string. Desc: category id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: posts_page / search
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * sort_by - Type: string. Desc: recent activity / newest / most comments / most viewed / most liked
 *
 * visitor_id - Type: guid.
 * @param {postSortInCategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postSortInCategory = function (params) {
    return { evid: 566, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} mobileBackToSiteClickParams
* @property {GUID} app_id - app_id
* @property {GUID} app_site_id - app_site_id
* @property {GUID} instance_id - null
* @property {string} member_id - the member_id after login to Wix forum
* @property {GUID} biToken - null
* @property {string} origin - categories_page, feed_page
* @property {GUID} post_stable_id - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: mobile -> back to site click. Evid: 547.
 * Event description: Event trigger when clicking on the home icon (mobile).

 * app_id - Type: guid. Desc: app_id
 *
 * app_site_id - Type: guid. Desc: app_site_id
 *
 * instance_id - Type: guid.
 *
 * member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: categories_page, feed_page
 *
 * post_stable_id - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {mobileBackToSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileBackToSiteClick = function (params) {
    return { evid: 547, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} likeClickedParams
* @property {string} action - add (used for new ones reaction added), replace, remove
* @property {GUID} app_id - null
* @property {GUID} app_site_id - null
* @property {boolean} flag - 0 - unliked / 1 - like
* @property {GUID} instance_id - instance id
* @property {string} member_id - null
* @property {GUID} biToken - site msid
* @property {string} origin - feed_page, post_page, search_results, user_profile
* @property {string} post_id - post_id guid
* @property {GUID} post_stable_id - null
* @property {string} reaction_type - reaction_type
* @property {string} site_member_id - the member_id after login to Wix forum
* @property {string} type - post, comment, reply
* @property {GUID} visitor_id - site visitor id
**/
/**
 * Name: like clicked. Evid: 586.
 * Event description: Event triggered after like button is clicked.

 * action - Type: string. Desc: add (used for new ones reaction added), replace, remove
 *
 * app_id - Type: guid.
 *
 * app_site_id - Type: guid.
 *
 * flag - Type: bool. Desc: 0 - unliked / 1 - like
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string.
 *
 * biToken - Type: guid. Desc: site msid
 *
 * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
 *
 * post_id - Type: string. Desc: post_id guid
 *
 * post_stable_id - Type: guid.
 *
 * reaction_type - Type: string. Desc: reaction_type
 *
 * site_member_id - Type: string. Desc: the member_id after login to Wix forum
 *
 * type - Type: string. Desc: post, comment, reply
 *
 * visitor_id - Type: guid. Desc: site visitor id
 * @param {likeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var likeClicked = function (params) {
    return { evid: 586, src: 69, endpoint: 'forums-uou', params: params };
};
/**
* @typedef {Object} mentionClickedFromPsotParams
* @property {GUID} app_id - app id
* @property {GUID} app_site_id - app site id
* @property {string} application_type - Web/OneApp
* @property {GUID} instance_id - instance id
* @property {string} member_id - member id
* @property {GUID} biToken - msid
* @property {GUID} post_stable_id - null
* @property {GUID} site_member_id - site_member_id
* @property {string} type - comment/ reply/post
* @property {GUID} uuid - uuid
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: mention clicked from published post. Evid: 573.
 * Event description: When a user clicks on a mention from published post/comment/reply.

 * app_id - Type: guid. Desc: app id
 *
 * app_site_id - Type: guid. Desc: app site id
 *
 * application_type - Type: string. Desc: Web/OneApp
 *
 * instance_id - Type: guid. Desc: instance id
 *
 * member_id - Type: string. Desc: member id
 *
 * biToken - Type: guid. Desc: msid
 *
 * post_stable_id - Type: guid.
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: comment/ reply/post
 *
 * uuid - Type: guid. Desc: uuid
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {mentionClickedFromPsotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mentionClickedFromPsot = function (params) {
    return { evid: 573, src: 69, endpoint: 'forums-uou', params: params };
};
//# sourceMappingURL=index.js.map